<div class="procedure-create-wrapper">
  <!-- HEADER -->
  <div class="page-header">
    <div class="page-header-icon">
      <span nz-icon nzType="medicine-box" nzTheme="outline"></span>
    </div>

    <div>
      <h2 class="page-header-title">Nowa procedura</h2>
      <p class="page-header-subtitle">Uzupełnij dane procedury medycznej</p>
    </div>
  </div>

  <form nz-form nzLayout="vertical" class="create-form">
    <!-- Dane podstawowe -->
    <nz-card class="form-card" [nzBordered]="false">
      <div class="card-section-header">
        <span nz-icon nzType="profile" nzTheme="outline" class="section-icon"> </span>

        <span>Dane podstawowe</span>
      </div>

      <div nz-row [nzGutter]="[24, 0]">
        <div nz-col [nzXs]="24" [nzSm]="18">
          <nz-form-item>
            <nz-form-label nzRequired>Nazwa procedury</nz-form-label>
            <nz-form-control
              [nzValidateStatus]="
                procedureForm.name().invalid() &&
                (procedureForm.name().touched() || submitted() || procedureForm.name().dirty())
                  ? 'error'
                  : ''
              "
            >
              <input nz-input placeholder="Nazwa procedury" [formField]="procedureForm.name" />
            </nz-form-control>
            <app-field-error
              [control]="procedureForm.name()"
              [submitted]="submitted()"
            ></app-field-error>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="6">
          <nz-form-item>
            <nz-form-label>Typ</nz-form-label>
            <nz-form-control
              [nzValidateStatus]="
                procedureForm.type().invalid() &&
                (procedureForm.type().touched() || submitted() || procedureForm.type().dirty())
                  ? 'error'
                  : ''
              "
            >
              <nz-select nzPlaceHolder="Wybierz modalność" [formField]="procedureForm.type">
                @for (item of modalities; track item.name) {
                  <nz-option [nzValue]="item.code" [nzLabel]="item.name!"> </nz-option>
                }
              </nz-select>
            </nz-form-control>
            <app-field-error
              [control]="procedureForm.type()"
              [submitted]="submitted()"
            ></app-field-error>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="8">
          <nz-form-item>
            <nz-form-label>Kod</nz-form-label>
            <nz-form-control
              [nzValidateStatus]="
                procedureForm.code().invalid() &&
                (procedureForm.code().touched() || submitted() || procedureForm.code().dirty())
                  ? 'error'
                  : ''
              "
            >
              <input nz-input placeholder="Kod procedury" [formField]="procedureForm.code" />
            </nz-form-control>
            <app-field-error
              [control]="procedureForm.code()"
              [submitted]="submitted()"
            ></app-field-error>
          </nz-form-item>
        </div>
      </div>
    </nz-card>

    <!-- Klasyfikacja -->
    <nz-card class="form-card" [nzBordered]="false">
      <div class="card-section-header">
        <span nz-icon nzType="tags" nzTheme="outline" class="section-icon"> </span>

        <span>Klasyfikacja</span>
      </div>

      <div nz-row [nzGutter]="[24, 0]">
        <div nz-col [nzXs]="24" [nzSm]="8">
          <nz-form-item>
            <nz-form-label>Kod ICD-9</nz-form-label>
            <nz-form-control
              [nzValidateStatus]="
                procedureForm.icd9Code().invalid() &&
                (procedureForm.icd9Code().touched() ||
                  submitted() ||
                  procedureForm.icd9Code().dirty())
                  ? 'error'
                  : ''
              "
            >
              <nz-input-wrapper>
                <input nz-input placeholder="ICD-9" [formField]="procedureForm.icd9Code" />
                <div nzInputAddonBefore>
                  <a>
                    <nz-icon
                      nzType="search"
                      nzTheme="outline"
                      (click)="showIcdCodePicker('icd9')"
                    />
                  </a>
                </div>
              </nz-input-wrapper>
            </nz-form-control>
            <app-field-error
              [control]="procedureForm.icd9Code()"
              [submitted]="submitted()"
            ></app-field-error>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="8">
          <nz-form-item>
            <nz-form-label>Obszar ciała</nz-form-label>
            <nz-form-control
              [nzValidateStatus]="
                procedureForm.bodyAreaCode().invalid() &&
                (procedureForm.bodyAreaCode().touched() ||
                  submitted() ||
                  procedureForm.bodyAreaCode().dirty())
                  ? 'error'
                  : ''
              "
            >
              <nz-select
                nzPlaceHolder="Wybierz kod obszaru"
                nzShowSearch
                [nzFilterOption]="filterOption"
                [formField]="procedureForm.bodyAreaCode"
              >
                @for (item of sortedBodyAreas(); track item.code) {
                  <nz-option [nzValue]="item.code" [nzLabel]="item.name!"> </nz-option>
                }
              </nz-select>
            </nz-form-control>
            <app-field-error
              [control]="procedureForm.bodyAreaCode()"
              [submitted]="submitted()"
            ></app-field-error>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="8">
          <nz-form-item>
            <nz-form-label>Punkty NFZ</nz-form-label>
            <nz-form-control
              [nzValidateStatus]="
                procedureForm.nhfPoints().invalid() &&
                (procedureForm.nhfPoints().touched() ||
                  submitted() ||
                  procedureForm.nhfPoints().dirty())
                  ? 'error'
                  : ''
              "
            >
              <input nz-input placeholder="Punkty NFZ" [formField]="procedureForm.nhfPoints" />
            </nz-form-control>
            <app-field-error
              [control]="procedureForm.nhfPoints()"
              [submitted]="submitted()"
            ></app-field-error>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="8">
          <nz-form-item>
            <nz-form-label>Domyślny czas wykonania</nz-form-label>
            <nz-form-control>
              <nz-input-group nzAddOnAfter="min">
                <input
                  nz-input
                  type="number"
                  placeholder="np. 20"
                  [formField]="procedureForm.defaultEtcInMinutes"
                />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </nz-card>

    <!-- Parametry badania -->
    <nz-card class="form-card" [nzBordered]="false">
      <div class="card-section-header">
        <span nz-icon nzType="setting" nzTheme="outline" class="section-icon"> </span>

        <span>Parametry badania</span>
      </div>

      <div nz-row [nzGutter]="[24, 0]">
        <div nz-col [nzXs]="24" [nzSm]="8">
          <nz-form-item>
            <nz-form-label>Z kontrastem</nz-form-label>
            <nz-form-control
              [nzValidateStatus]="
                procedureForm.withContrast().invalid() &&
                (procedureForm.withContrast().touched() ||
                  submitted() ||
                  procedureForm.withContrast().dirty())
                  ? 'error'
                  : ''
              "
            >
              <nz-select nzPlaceHolder="Wybierz" [formField]="procedureForm.withContrast">
                <nz-option nzValue="" nzLabel="Nie dotyczy"></nz-option>
                <nz-option nzValue="true" nzLabel="Tak"></nz-option>
                <nz-option nzValue="false" nzLabel="Nie"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="8">
          <nz-form-item>
            <nz-form-label>Kręgosłup</nz-form-label>
            <nz-form-control
              [nzValidateStatus]="
                procedureForm.withSpine().invalid() &&
                (procedureForm.withSpine().touched() ||
                  submitted() ||
                  procedureForm.withSpine().dirty())
                  ? 'error'
                  : ''
              "
            >
              <nz-select nzPlaceHolder="Wybierz" [formField]="procedureForm.withSpine">
                <nz-option nzValue="" nzLabel="Nie dotyczy"></nz-option>
                <nz-option nzValue="true" nzLabel="Tak"></nz-option>
                <nz-option nzValue="false" nzLabel="Nie"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="8">
          <nz-form-item>
            <nz-form-label>Przed i po kontraście</nz-form-label>
            <nz-form-control
              [nzValidateStatus]="
                procedureForm.withPrePostContrast().invalid() &&
                (procedureForm.withPrePostContrast().touched() ||
                  submitted() ||
                  procedureForm.withPrePostContrast().dirty())
                  ? 'error'
                  : ''
              "
            >
              <nz-select nzPlaceHolder="Wybierz" [formField]="procedureForm.withPrePostContrast">
                <nz-option nzValue="" nzLabel="Nie dotyczy"></nz-option>
                <nz-option nzValue="true" nzLabel="Tak"></nz-option>
                <nz-option nzValue="false" nzLabel="Nie"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </nz-card>
  </form>

  <div class="button-footer-wrapper">
    <a nz-button nzType="default" routerLink="/procedures">
      <span nz-icon nzType="arrow-left"></span>
      Wstecz
    </a>

    <button nz-button nzType="primary" (click)="submit()" [nzLoading]="isSubmitting()">
      <span nz-icon nzType="save"></span>
      Zapisz procedurę
    </button>
  </div>
</div>
